import { Box } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import MicIconOff from '@mui/icons-material/MicOff';

import AssistantImage from '@public/images/assistant/myta/assistant.jpg';
import {
  assistantSize,
  showMuteButtonOnHover,
} from '@core/assistant/constants';
import { useAssistant } from '@core/assistant/providers/Provider';

import { useStyles } from './styles';

const Assistant = () => {
  const classes = useStyles();

  const { stopPlayback, isMuted, setIsMuted } = useAssistant();

  const handleMicClick = () => {
    try {
      stopPlayback();
    } catch (error) {
      //
    }
    setIsMuted();
  };

  return (
    <Box sx={classes.box}>
      <div
        className={'assistant' + (showMuteButtonOnHover ? ' with-hover' : '')}
      >
        <img
          className="assistant-avatar"
          id="ai-assistant"
          src={AssistantImage}
          style={{
            width: `${assistantSize.width}px`,
            height: `${assistantSize.height}px`,
          }}
        />
        <div
          className={'assistant-mute' + (isMuted ? ' muted' : '')}
          onClick={() => handleMicClick()}
        >
          {isMuted ? <MicIconOff /> : <MicIcon />}
        </div>
        <canvas id="ai-assistant-canvas" className="ai-assistant-canvas" />
      </div>
    </Box>
  );
};

export default Assistant;
